export enum PreviousPage {
  CONTROL_BOARD = "CONTROL_BOARD",
  CREATE_PROJECT = "CREATE_PROJECT",
  MATHERIAUTHEQUE_PROJECT = "MATHERIAUTHEQUE_PROJECT",
  PHASES = "PHASES",
  TEAM = "TEAM",
}
